import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'
import BtnPrimary from '../../atom/btn-primary/index.tsx'
import { DemoBtn } from '../../atom/demo-buttom/index.tsx'
import HeroReviews from '../../molecule/hero-reviews/index.tsx'
import { trackMarketingEvent } from '../../../helpers/analytics.ts'
import { normalizeLanguage, withLang } from '../../../utils/langPath.ts'
import './index.css'

interface Props {
	isHome?: boolean;
	title?: string;
	subtitle?: string | []
}

const HeroSection: React.FC<Props> = ({
	isHome = true,
	title,
	subtitle
}) => {
	const { t, i18n } = useTranslation('home')
	const { t: tCommon } = useTranslation()
	const navigate = useNavigate()
	const lang = normalizeLanguage(i18n.language)

	// Only show demo button and reviews for hr/sr/bs languages
	const isSlavicLanguage = ['hr', 'sr', 'bs'].includes(i18n.language)

	const displayTitle = title || t('hero.title')
	const displaySubtitle = subtitle || t('hero.subtitle')

	return (
		<section className='hero-main-container'>
			<div className='hero-content-container'>
				<h1 className='hero-main-title'>
					{displayTitle}
				</h1>
				<p className='hero-sub-title'>
					{displaySubtitle}
				</p>

				<BtnPrimary title={tCommon('buttons.secureMemories')} onPress={() => {
					trackMarketingEvent('cta_click', 'hero_price')
					navigate(withLang(lang, '/price'))
				}} />
			</div>

			{isSlavicLanguage && (
				<Link to={withLang(lang, '/demo')} onClick={() => trackMarketingEvent('cta_click', 'hero_demo')}>
					<div className='hero-demo-btn-container'>
						<DemoBtn />
					</div>
				</Link>
			)}

			{isSlavicLanguage && (
				<div className='hero-reviews-container'>
					<HeroReviews />
				</div>
			)}
		</section>
	)
}

export default HeroSection
